// Lets the NotFound page mark the in-flight navigation as a 404 BEFORE
// usePostHogPageview's $pageview capture fires, so that pageview can be
// tagged instead of recorded as if it were real content. NotFound sets this
// from a useLayoutEffect and usePostHogPageview reads+clears it from a
// regular useEffect — React guarantees ALL layout effects across the tree
// run before ANY passive effect in the same commit, so ordering holds
// regardless of whether NotFound is a parent, sibling, or lazy-mounted child.
let pendingNotFound = false;

export function markPendingNotFound(): void {
  pendingNotFound = true;
}

export function consumePendingNotFound(): boolean {
  const value = pendingNotFound;
  pendingNotFound = false;
  return value;
}
